var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.1665 28C22.7939 28 28.1665 22.6274 28.1665 16C28.1665 9.37258 22.7939 4 16.1665 4C9.53909 4 4.1665 9.37258 4.1665 16C4.1665 22.6274 9.53909 28 16.1665 28Z",
    fill: "#B8772A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 28C22.7939 28 28.1665 22.6274 28.1665 16C28.1665 9.37258 22.7939 4 16.1665 4C9.53909 4 4.1665 9.37258 4.1665 16C4.1665 22.6274 9.53909 28 16.1665 28Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1665 18H17.1665C18.0948 18 18.985 17.6313 19.6414 16.9749C20.2978 16.3185 20.6665 15.4283 20.6665 14.5C20.6665 13.5717 20.2978 12.6815 19.6414 12.0251C18.985 11.3687 18.0948 11 17.1665 11H13.1665V21",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterCircle);
export default __webpack_public_path__ + "static/media/LetterCircle.d974b5104f62e32fbfcf5731dba839ce.svg";
export { ForwardRef as ReactComponent };